export const INCREMENT_DEBT = "INCREMENT_DEBT";
export const INCREMENT_CREDIT = "INCREMENT_CREDIT";
export const INCREMENT_PROMO = "INCREMENT_PROMO";
export const LOAD_REQUEST = "LOAD_REQUEST";
export const LOAD_SUCCESS = "LOAD_SUCCESS";
export const LOAD_FAILURE = "LOAD_FAILURE";
